'use client';

import React from 'react';
import HeroSection from './HeroSection';
import StoryTimeline from './StoryTimeline';
import WisdomSection from './WisdomSection';
import DisplayedBlessings from './DisplayedBlessings';
import BlessingForm from './BlessingForm';

const OurStoryInteractive = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <StoryTimeline />
      <WisdomSection />
      <DisplayedBlessings />
      <div id="blessing-form">
        <BlessingForm />
      </div>
    </div>
  );
};

export default OurStoryInteractive;